const main = {
  // 页面标题和欢迎信息
  policyRegulation: "政策法规",
  blockchainKnowledge: "区块链行业知识",
  blockchainCaseInvestigation: "区块链案件侦查实录",

  // 状态提示
  loadingText: "拼命加载中",
  noDataText: "暂无数据",
};

// HelpHome 页面内容
const helpHome = {
  helpCenterTitle: "帮助中心",
  expertService: "专家服务",
  productFunctionIntro: "产品功能介绍",
};

// judgmentBookDocuments 页面内容
const judgmentBookDocuments = {
  originalText: "原文",
};

// National-involvment 页面内容
const nationalInvolvment = {
  // 页面标题
  judicialPrecedentTitle: "司法判例参考",

  // 搜索表单
  judgmentTitlePlaceholder: "请输入文书标题",
  caseNumberPlaceholder: "请输入案号",
  chargePlaceholder: "请输入案由",
  caseTypePlaceholder: "请选择案件",
  regionPlaceholder: "请选择(省/市)",
  platformPlaceholder: "请选择平台",
  procedurePlaceholder: "请选择程序",

  // 日期选择器
  dateRangeSeparator: "至",
  startDatePlaceholder: "开始日期",
  endDatePlaceholder: "结束日期",

  // 按钮
  resetButton: "重置",
  searchButton: "查询",

  // 状态提示
  loadingText: "拼命加载中",
  noDataText: "暂无数据",

  // 案件信息标签
  caseTypeLabel: "案件类型",
  caseNumberLabel: "案号",
  chargeLabel: "案由",
  regionLabel: "地区",
  platformLabel: "涉及平台",
  currencyLabel: "涉及币种",

  // 默认选项
  allCases: "全部案件",
  allProvinces: "全部省份",
  allCities: "全部城市",
  allCurrencies: "全部币种",
  allPlatforms: "全部平台",
  allProcedures: "全部程序",
};

// production-fun 页面内容
const productionFun = {
  // 页面标题和描述
  productFunctionIntro: "产品功能介绍",
  productDescription:
    "产品以虚拟币地址为切入点，以链上交易溯源及匿名身份解析为核心，用于打击涉虚拟货币新型犯罪的一站式查控平台，协助执法机关解决虚拟币案件中的各类数据分析、案情拆解、及分析研判难题。",

  // 标签页
  productDemo: "产品演示",
  analysisResearch: "研判分析",
  evidenceManagement: "调证管理",
  dataDashboard: "数据看板",

  // 功能模块
  addressHashUserAnalysis: "地址、哈希、调证用户分析",
  addressHashUserDesc:
    "一键查询地址的基本交易数据、余额与标签。初步了解地址交易情况和标签属性",
  demoVideo: "演示视频",

  characterAnalysis: "人物分析",
  characterAnalysisDesc:
    "针对已解析的司法调证文件，用人物分析ID搜索，可轻松查阅调证文件内容，完全掌握人物账户情况",

  caseAnalysis: "案件分析",
  caseAnalysisDesc:
    "建立案件画布，图形化展现链上转账关系，关注相关地址资金流向，深入查询地址交易详情",
  demoVideoCaseManagement: "演示视频-案件管理",
  demoVideoCanvasAnalysis: "演示视频-画布分析",

  addressMonitoring: "地址监控",
  addressMonitoringDesc:
    "监控特定地址并实时通知链上转账信息，密切关注地址资金动向",

  aiModel: "AI模型",
  aiModelDesc:
    "查询涉案地址手续费来源，快速得出地址的实控人线索，方便侦查人员进一步司法调证",

  labelManagement: "标签管理",
  labelManagementDesc: "地址标签自主管理，实时同步至画布，分析效率显著提升",

  evidenceSuggestion: "调证建议",
  evidenceSuggestionDesc:
    "一键生成、下载各大平台司法调证建议文书，步骤详尽，让司法调证“不迷路”",

  evidenceUser: "调证用户",
  evidenceUserDesc: "调证返回文件全量整理，调证结果即刻查询了解",

  evidenceUpload: "调证上传",
  evidenceUploadDesc:
    "支持所有主流交易所调证文件上传解析。可以使用解析生成的人物分析ID在案件画布中直接分析，不仅能够查看人物账户详情，还能直观展示人物转账关系",

  transactionData: "交易数据",
  transactionDataDesc: "案件关键地址交易数据一览无余，案件态势一目了然",

  balanceData: "余额数据",
  balanceDataDesc: "实时更新案件地址余额，关注案件价值",
};

// prosecuteBook 页面内容
const prosecuteBook = {
  // 页面标题
  indictmentTitle: "起诉书",

  // 搜索表单
  titlePlaceholder: "请输入文书标题",
  caseNumberPlaceholder: "请输入案号",
  caseTypePlaceholder: "请选择案件",
  regionPlaceholder: "请选择(省/市)",
  platformPlaceholder: "请选择平台",
  currencyPlaceholder: "请选择币种",

  // 日期选择器
  dateRangeSeparator: "至",
  startDatePlaceholder: "开始日期",
  endDatePlaceholder: "结束日期",

  // 按钮
  resetButton: "重置",
  searchButton: "查询",

  // 状态提示
  loadingText: "拼命加载中",
  noDataText: "暂无数据",

  // 案件信息标签
  caseTypeLabel: "案件类型",
  caseNumberLabel: "案号",
  regionLabel: "地区",
  platformLabel: "涉及平台",
  currencyLabel: "涉及币种",

  // 默认选项
  allCases: "全部案件",
  allProvinces: "全部省份",
  allCities: "全部城市",
  allCurrencies: "全部币种",
  allPlatforms: "全部平台",
  allProcedures: "全部程序",
};

// ReferenceDocuments 页面内容
const referenceDocuments = {
  // 状态提示
  loadingText: "拼命加载中",

  // 文档信息标签
  courtLabel: "审理法院：",
  caseNumberLabel: "案号：",
  judgmentDateLabel: "裁判日期：",
  chargeLabel: "案由：",
  legalBasisLabel: "法律依据",
};

export default {
  ...main,
  ...helpHome,
  ...judgmentBookDocuments,
  ...nationalInvolvment,
  ...productionFun,
  ...prosecuteBook,
  ...referenceDocuments,
  // 子模块
};
